// src/components/cross-sell-date-range/cross-sell-date-range.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query CrossSellRateCalendarQuery(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $shoppingPath: ShoppingPathType\n    $selectedOffers: [ActivityOfferNaturalKeyInput!]\n  ) {\n    activityInfo(context: $context, activityId: $activityId, dateRange: $dateRange, shoppingPath: $shoppingPath, selectedOffers: $selectedOffers) {\n      availabilities {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        date {\n          ...DateFragment\n        }\n        formattedDate {\n          text\n        }\n        highlighted\n        formattedPrice\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkDateRange } from "uitk-react-date-range";
var __Query = gql(_templateObject());
var CrossSellDateRange = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, onClick = param.onClick;
    var _data_activityInfo_availabilities_find, _data, _dateRangeData;
    var context = useBexApi().context;
    var trackClick = useClickTracker();
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, previousData = _useQuery.previousData;
    var firstAvailableDate = (_data = data) === null || _data === void 0 ? void 0 : (_data_activityInfo_availabilities_find = _data.activityInfo.availabilities.find(function(date) {
        return date.highlighted;
    })) === null || _data_activityInfo_availabilities_find === void 0 ? void 0 : _data_activityInfo_availabilities_find.date;
    var _React_useState = _sliced_to_array(React.useState(firstAvailableDate), 2), highlightedDate = _React_useState[0], setHighlightedDate = _React_useState[1];
    React.useEffect(function() {
        setHighlightedDate(firstAvailableDate);
    }, [
        firstAvailableDate
    ]);
    if (loading && !previousData) {
        return /* @__PURE__ */ React.createElement(UitkDateRange, {
            loading: true,
            results: []
        });
    }
    var dateRangeData = loading ? previousData : data;
    if (error || !((_dateRangeData = dateRangeData) === null || _dateRangeData === void 0 ? void 0 : _dateRangeData.activityInfo.availabilities.length)) {
        return null;
    }
    var availabilities = dateRangeData.activityInfo.availabilities;
    var offerDates = availabilities.map(function(availability) {
        var date = availability.date, formattedPrice = availability.formattedPrice, accessibility = availability.accessibility, analytics = availability.analytics, formattedDate = availability.formattedDate;
        var _formattedDate_text;
        return {
            dateText: (_formattedDate_text = formattedDate.text) !== null && _formattedDate_text !== void 0 ? _formattedDate_text : "",
            text: formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "-",
            accessibilityMessage: accessibility,
            analytics: {
                id: analytics.referrerId,
                description: analytics.linkName,
                callback: function(id, description) {
                    trackClick(id, description);
                }
            },
            onClickCallback: function() {
                return onClick(date, setHighlightedDate);
            },
            selected: highlightedDate === date
        };
    });
    return /* @__PURE__ */ React.createElement(UitkDateRange, {
        results: offerDates
    });
};
CrossSellDateRange.displayName = "sharedui-CrossSellDateRange";
export { CrossSellDateRange };
//# sourceMappingURL=index.js.map